import React from "react";
import Sale from "../../../../utilities/data/model/Sale";

export type InvoiceRootScreenContextType = {
  // A valid sale that can be used to create a quote
  sale: Sale;
};

export const InvoiceRootScreenContext = React.createContext<
  InvoiceRootScreenContextType | undefined
>(undefined);
